<template>
  <div class="about-page">
    <!-- 页面内部 Banner -->
    <section class="page-banner">
      <!-- <div class="container">
        <h1>公司概况</h1>
        <el-breadcrumb separator="/" class="breadcrumb">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>公司概况</el-breadcrumb-item>
        </el-breadcrumb>
      </div> -->
      <!-- 数量为1时，显示单张图片 -->
      <div v-if="bannerSlides.length === 1" class="banner-single-bg">
        <img :src="bannerSlides[0].carouselUrl" class="bg-img">
      </div>

      <!-- 数量大于1时，显示轮播幻灯片 -->
      <div v-else-if="bannerSlides.length > 1" class="banner-slider-bg">
        <div v-for="(slide, idx) in bannerSlides" :key="idx" class="bg-slide" :class="{ active: currentBanner === idx }">
          <img :src="slide.carouselUrl" class="bg-img">
        </div>
      </div>

      <div class="container">
        <h1>公司概况</h1>
        <el-breadcrumb separator="/" class="breadcrumb">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>公司概况</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </section>

    <!-- 主体内容与侧边栏 -->
    <section class="content-wrapper">
      <div class="container layout-grid">
        <!-- 侧边导航 -->
        <aside class="sidebar">
          <nav class="side-nav">
            <h3>公司概况</h3>
            <ul>
              <li v-for="(menu, index) in menuList" :key="menu.id" :class="{ active: activeSection === menu.sectionId || (index === 0 && !activeSection) }">
                <a @click.prevent="handleMenuClick(menu)">
                  <i class="el-icon-document"></i> {{ menu.name }}
                </a>
              </li>
            </ul>
          </nav>
        </aside>

        <!-- 主内容区 -->
        <div class="main-content">
          <!-- 公司简介 -->
          <section id="intro" class="content-section" v-if="hasSection('intro')">
            <h2 class="section-title">公司简介</h2>
            <div class="intro-text">
              <div v-html="companyDes.value"></div>
            </div>
          </section>

          <!-- 发展历程 -->
          <section id="history" class="content-section" v-if="hasSection('history')">
            <h2 class="section-title">发展历程</h2>
            <div class="image-wrapper">
              <div class="placeholder-img">
                 <div v-html="companyHistory.value"></div>
              </div>
            </div>
          </section>

          <!-- 组织架构 -->
          <section id="organization" class="content-section" v-if="hasSection('organization')">
            <h2 class="section-title">组织架构</h2>
            <div v-html="zuzhijiagou.value"></div>
          </section>

          <!-- 企业文化 -->
          <section id="culture" class="content-section" v-if="hasSection('culture')">
            <h2 class="section-title">企业文化</h2>
            <div class="culture-cards">
              <div v-html = 'qiyewenhua.value'></div>
            </div>
          </section>

          <!-- 联系我们 -->
          <section id="contact" class="content-section" v-if="hasSection('contact')">
            <h2 class="section-title">联系我们</h2>
            <div class="contact-grid">
              <div class="contact-box">
                <i class="el-icon-location-information"></i>
                <h4>公司地址</h4>
                <p>{{ $store.state.siteConfig.showAddress }}</p>
              </div>
              <div class="contact-box">
                <i class="el-icon-time"></i>
                <h4>工作时间</h4>
                <p>{{$store.state.siteConfig.showOther}}</p>
              </div>
              <div class="contact-box">
                <i class="el-icon-message"></i>
                <h4>电子邮箱</h4>
                <p>{{ $store.state.siteConfig.showEmail }}</p>
              </div>
            </div>
            <div class="contact-grid2">

              <div class="contact-box">
                <i class="el-icon-printer"></i>
                <h4>传真号</h4>
                <p>{{$store.state.siteConfig.showFax}}</p>
              </div>
              <div class="contact-box">
                <i class="el-icon-phone"></i>
                <h4>联系电话</h4>
                <p>{{ $store.state.siteConfig.showPhone }}</p>
              </div>
            </div>
           
            <hr />
            <!-- 纪检工作部 -->
            <div class="discipline-box">
              <div class="discipline-header">
                <h3>金控集团纪检工作部</h3>
              </div>
              <div class="discipline-content">
                <div class="discipline-item">
                  <i class="el-icon-phone"></i>
                  <span class="discipline-label">电话</span>
                  <span class="discipline-value">{{ jkdh.value }}</span>
                </div>
                <div class="discipline-item">
                  <i class="el-icon-message"></i>
                  <span class="discipline-label">邮箱</span>
                  <span class="discipline-value">{{ jkyx.value }}</span>
                </div>
              </div>
            </div>

             <div class="map-view" v-if="$store.state.siteConfig.showMap === '1'">
                <BaiduMap
                  v-if="$store.state.siteConfig.showAddress"
                  :address="$store.state.siteConfig.showAddress"
                  height="350px"
                />
            </div>
          </section>

        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getSubMenuList, getBannerList, getLabelList  } from '@/api/menu'
import BaiduMap from '@/components/BaiduMap.vue'

export default {
  name: 'About',
  components: { BaiduMap },
  data() {
    return {
      bannerSlides: [],
      currentBanner: 0,
      bannerTimer: null,
      activeSection: null,
      menuList: [],
      pcode: this.$route.query.id,
      companyDes: {},
      companyHistory: {},
      qiyewenhua: {},
      zuzhijiagou: {},
      mapurl: {},
      jkdh: {},
      jkyx: {}
    }
  },
  watch: {
    // 监听路由参数变化，重新获取菜单数据
    '$route.query.scode': {
      handler(newId) {
        if (newId) {
          this.pcode = newId
          this.fetchSubMenus()
        }
      },
      immediate: false
    }
  },
  created() {
    this.fetchBanner("gsgk");
    this.fetchSubMenus()
    this.fetchLabel("companyDes");
    this.fetchLabel("companyHistory");
    this.fetchLabel("qiyewenhua");
    this.fetchLabel("zuzhijiagou");
    this.fetchLabel("mapurl");
    this.fetchLabel("jkdh");
    this.fetchLabel("jkyx");
  },
  mounted() {
    this.startBannerTimer();
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
     if (this.bannerTimer) {
      clearInterval(this.bannerTimer);
    }
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    async fetchSiteConfig(name) {
      try {
        const res = await getSiteConfig()
        if (res.code === 0) {
          if ( name === "company.other") {
            this.workTime = res.msg || {}
          }
        }
      } catch (error) {
        console.error('获取站点配置失败', error)
      }
    },
    startBannerTimer() {
      this.bannerTimer = setInterval(() => {
        if (this.bannerSlides.length > 1) {
          this.currentBanner = (this.currentBanner + 1) % this.bannerSlides.length;
        }
      }, 4000);
    },
    async fetchBanner(groupCode) {
      try {
        const res = await getBannerList({ groupCode })
        if (res.code === 0) {
          this.bannerSlides = res.rows || []
        } 
      } catch (error) {
        console.error('获取轮播图失败', error)
      }
    },
    async fetchLabel(name) {
      try {
        const res = await getLabelList({ name })
        if (res.code === 0) {
          this[name] = res.data || {}
        } 
      } catch (error) {
        console.error('获取轮播图失败', error)
      }
    },
    async fetchSubMenus() {
      try {
        const res = await getSubMenuList(this.pcode)
        if (res.code === 0) {
          this.menuList = (res.rows || []).map(item => {
            let sectionId = '';
            if (item.name.includes('简介')) sectionId = 'intro';
            else if (item.name.includes('历程')) sectionId = 'history';
            else if (item.name.includes('架构')) sectionId = 'organization';
            else if (item.name.includes('文化')) sectionId = 'culture';
            else if (item.name.includes('联系')) sectionId = 'contact';
            return { ...item, sectionId };
          });

          if (this.menuList.length > 0 && !this.activeSection) {
            this.activeSection = this.menuList[0].sectionId;
          }
        }
      } catch (error) {
        console.error('获取二级菜单失败', error)
      }
    },
    hasSection(sectionId) {
      return this.menuList.some(item => item.sectionId === sectionId);
    },
    handleMenuClick(menu) {
      if (menu.sectionId) {
        this.scrollTo(menu.sectionId);
      }
    },
    scrollTo(id) {
      const el = document.getElementById(id)
      if (el) {
        const offset = 90 // Account for sticky nav bar if any
        window.scrollTo({
          top: el.offsetTop - offset,
          behavior: 'smooth'
        })
        this.activeSection = id
      }
    },
    handleScroll() {
      // 简单的高亮逻辑: 判断哪个部分在可视区域内
      const sections = ['intro', 'history', 'organization', 'culture', 'contact']
      const scrollY = window.scrollY + 100
      
      for (const section of sections) {
        const el = document.getElementById(section)
        if (el && el.offsetTop <= scrollY && el.offsetTop + el.offsetHeight > scrollY) {
          this.activeSection = section
          break
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$primary-blue: #1a3a5c;
$accent-red: #1a3a5c;
$light-bg: #f5f8fc;
$border: #e8edf3;
$text-main: #333;
$text-secondary: #666;

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* ---- Banner 头图 ---- */
.page-banner {
  
  background-size: cover;
  background-color: $primary-blue; /* Fallback */
  color: #fff;
  padding: 60px 0;
  position: relative;
  overflow: hidden;
  width: 100%;
  
 

      .banner-single-bg, .banner-slider-bg {
        position: absolute;
        inset: 0;
        z-index: 0;
        overflow: hidden;
      }

      .bg-slide {
        position: absolute;
        inset: 0;
        opacity: 0;
        transition: opacity 0.8s ease;
        &.active { opacity: 1; }
      }

      .bg-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
  }

  .container {
    position: relative;
    z-index: 1;
  }

  h1 {
    font-size: 2.2rem;
    font-weight: 600;
    margin: 0 0 15px 0;
    letter-spacing: 2px;
  }
  
  ::v-deep .el-breadcrumb__inner,
  ::v-deep .el-breadcrumb__separator {
    color: rgba(255, 255, 255, 0.8) !important;
  }
  ::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    color: #fff !important;
  }
}

/* ---- 内容布局 Grid ---- */
.content-wrapper {
  padding: 50px 0;
  background: #fff;
}

.layout-grid {
  display: flex;
  gap: 40px;
  align-items: flex-start;
}

/* ---- 侧边栏 ---- */
.sidebar {
  width: 250px;
  flex-shrink: 0;
  position: sticky;
  top: 100px;

  .side-nav {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.06);
    overflow: hidden;

    h3 {
      background: $primary-blue;
      color: #fff;
      margin: 0;
      padding: 16px 20px;
      font-size: 1.1rem;
      font-weight: 500;
    }

    ul {
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        border-bottom: 1px solid $border;
        &:last-child { border-bottom: none; }

        a {
          display: block;
          padding: 15px 20px;
          color: $text-main;
          text-decoration: none;
          cursor: pointer;
          transition: all 0.2s;
          
          i { margin-right: 8px; color: #999; transition: color 0.2s; }

          &:hover {
            background: $light-bg;
            color: $accent-red;
            i { color: $accent-red; }
          }
        }

        &.active a {
          background: $light-bg;
          color: $accent-red;
          font-weight: bold;
          border-left: 3px solid $accent-red;
          i { color: $accent-red; }
        }
      }
    }
  }
}

/* ---- 主内容区 ---- */
.main-content {
  flex: 1;
  min-width: 0; /* 防止内容撑破 flex */
}

.content-section {
  margin-bottom: 60px;
  scroll-margin-top: 100px;
  overflow-x: hidden;
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  
  /* 防止富文本图片溢出 */
  ::v-deep .intro-text img, .placeholder-img img, .culture-cards img {
    max-width: 100% !important;
    height: auto !important;
  }
  
  /* 富文本内容换行规则 */
  ::v-deep .intro-text, 
  ::v-deep .placeholder-img, 
  ::v-deep .culture-cards {
    width: 100%;
    word-wrap: break-word;
    word-break: break-word;
    overflow-wrap: break-word;
    overflow-x: auto; /* 允许超出时水平滚动 */
    
    * {
      max-width: 100% !important;
      box-sizing: border-box;
      word-wrap: break-word;
      word-break: break-word;
      overflow-wrap: break-word;
    }
    
    table {
      max-width: 100% !important;
      /* display: block; */ /* 移除以恢复表格原生渲染布局，防止出现右侧黑边 */
      /* width: 100% !important; */ /* 移除以避免非 100% 宽度的表格被强行拉伸 */
    }
    
    pre,
    code {
      white-space: pre-wrap;
      word-wrap: break-word;
      word-break: break-word;
      overflow-wrap: break-word;
    }
    
    p {
      overflow-wrap: break-word;
      word-wrap: break-word;
      word-break: break-word;
    }
    
    a {
      word-break: break-all;
    }
  }

  &:last-child {
    margin-bottom: 0;
  }

  .section-title {
    font-size: 1.6rem;
    color: $primary-blue;
    margin-top: 0;
    margin-bottom: 25px;
    padding-bottom: 12px;
    border-bottom: 2px solid $border;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: -2px;
      width: 40px;
      height: 2px;
      background: $accent-red;
    }
  }
}

/* ---- 公司简介 ---- */
.intro-text {
  p {
    font-size: 1rem;
    line-height: 1.8;
    color: $text-secondary;
    margin-bottom: 15px;
    text-indent: 2em;
    text-align: justify;
  }
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-top: 30px;

  .stat-item {
    background: $light-bg;
    padding: 25px 15px;
    text-align: center;
    border-radius: 8px;
    transition: transform 0.3s, box-shadow 0.3s;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 6px 15px rgba(0,0,0,0.08);
    }

    .stat-num {
      display: inline-block;
      font-size: 2.2rem;
      font-weight: 700;
      color: $accent-red;
      line-height: 1;
    }
    .stat-unit {
      color: $accent-red;
      font-size: 1rem;
      margin-left: 2px;
    }
    .stat-label {
      display: block;
      margin-top: 8px;
      font-size: 0.95rem;
      color: $text-secondary;
    }
  }
}

/* ---- 发展历程 & 图片占位 ---- */
.image-wrapper {
  .placeholder-img {
    width: 100%;
  }
}

/* ---- 组织架构 (纯CSS绘制) ---- */
.org-chart {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: $light-bg;
  padding: 40px 20px;
  border-radius: 8px;

  .org-node {
    background: #fff;
    border: 1px solid #dcdfe6;
    padding: 10px 25px;
    border-radius: 4px;
    font-weight: 500;
    color: $primary-blue;
    box-shadow: 0 2px 5px rgba(0,0,0,0.05);
    text-align: center;
    &.top-node {
      background: $primary-blue;
      color: #fff;
      border-color: $primary-blue;
    }
    &.sub-node {
      margin-bottom: 10px;
      font-size: 0.9rem;
      padding: 8px 15px;
    }
    &.line-break {
      line-height: 1.3;
    }
  }

  .org-line {
    width: 2px;
    height: 25px;
    background: #dcdfe6;
  }

  .org-level {
    display: flex;
    gap: 40px;
    position: relative;
    &::before {
      content: '';
      position: absolute;
      top: -25px;
      left: 25%;
      right: 25%;
      height: 2px;
      background: #dcdfe6;
    }
  }

  .org-departments {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
    width: 100%;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: -25px;
      left: 16.66%;
      right: 16.66%;
      height: 2px;
      background: #dcdfe6;
    }

    .dept-col {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        top: -25px;
        left: 50%;
        width: 2px;
        height: 25px;
        background: #dcdfe6;
      }

      h4 {
        text-align: center;
        margin: 0 0 15px 0;
        color: $accent-red;
        font-size: 1.05rem;
      }
    }
  }
}

/* ---- 企业文化 ---- */
.culture-cards {
  display: flex;
  flex-direction: column;
  gap: 20px;

  .culture-card {
    background: #fff;
    border: 1px solid $border;
    border-radius: 8px;
    padding: 25px;
    display: flex;
    gap: 20px;
    transition: box-shadow 0.3s;

    &:hover { box-shadow: 0 4px 15px rgba(0,0,0,0.08); }

    .card-icon {
      font-size: 2.2rem;
      color: $accent-red;
      background: rgba($accent-red, 0.08);
      width: 60px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      flex-shrink: 0;
    }

    .card-info {
      flex: 1;
      h4 {
        margin: 5px 0 10px 0;
        font-size: 1.15rem;
        color: $primary-blue;
      }
      p {
        font-size: 0.95rem;
        color: $text-secondary;
        line-height: 1.6;
        margin-bottom: 8px;
        &:last-child { margin-bottom: 0; }
        
        strong { color: $text-main; }
        &.highlight { font-weight: 500; color: $text-main; }
      }
    }
  }
}

/* ---- 联系我们 ---- */
.contact-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-bottom: 30px;

  .contact-box {
    background: $light-bg;
    padding: 25px 20px;
    border-radius: 8px;
    text-align: center;
    border: 1px solid transparent;
    transition: all 0.3s;

    &:hover {
      border-color: rgba($primary-blue, 0.2);
      transform: translateY(-3px);
    }

    i {
      font-size: 2rem;
      color: $primary-blue;
      margin-bottom: 12px;
    }
    h4 {
      font-size: 1.1rem;
      margin: 0 0 8px 0;
      color: $text-main;
    }
    p {
      margin: 0;
      color: $text-secondary;
      font-size: 0.95rem;
      line-height: 1.5;
    }
  }
}
.contact-grid2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 30px;

  .contact-box {
    background: $light-bg;
    padding: 25px 20px;
    border-radius: 8px;
    text-align: center;
    border: 1px solid transparent;
    transition: all 0.3s;

    &:hover {
      border-color: rgba($primary-blue, 0.2);
      transform: translateY(-3px);
    }

    i {
      font-size: 2rem;
      color: $primary-blue;
      margin-bottom: 12px;
    }
    h4 {
      font-size: 1.1rem;
      margin: 0 0 8px 0;
      color: $text-main;
    }
    p {
      margin: 0;
      color: $text-secondary;
      font-size: 0.95rem;
      line-height: 1.5;
    }
  }
}


.map-view {
  .map-placeholder {
    background: #eaeef3;
    height: 350px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #8c98a5;

    .map-icon { font-size: 3rem; margin-bottom: 10px; }
    p { margin-bottom: 15px; }
  }
}

/* 纪检工作部 */
.discipline-box {
  margin-top: 40px;
  background: linear-gradient(135deg, #f5f9ff 0%, #fff 100%);
  border: 1px solid #c2dcf7;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 4px 16px rgba(255, 102, 102, 0.08);

  .discipline-header {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 2px solid #c2dcf7;

    i {
      font-size: 1.8rem;
      color: #1a4a7a;
      margin-right: 12px;
    }

    h3 {
      margin: 0;
      font-size: 1.3rem;
      color: #1a4a7a;
      font-weight: 600;
    }
  }

  .discipline-content {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 24px;
  }

  .discipline-item {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    border: 1px solid #c2dcf7;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 4px 12px rgba(214, 48, 49, 0.12);
      border-color: #c2dcf7;
    }

    i {
      font-size: 1.5rem;
      color: #1a4a7a;
      margin-right: 16px;
    }

    .discipline-label {
      font-size: 0.95rem;
      color: $text-secondary;
      margin-right: 8px;
    }

    .discipline-value {
      font-size: 1.05rem;
      color: #1a4a7a;
      font-weight: 500;
    }
  }
}

/* ================== 响应式适配 ================== */

/* ---- Tablet (1024px 以下) ---- */
@media (max-width: 1024px) {
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .contact-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* ---- Mobile & Tablet (1000px 以下) ---- */
@media (max-width: 1000px) {
  .about-page {
    overflow-x: hidden;
    width: 100%;
  }
  
  .page-banner {
    padding: 30px 0;
    overflow: hidden;
    width: 100%;
    h1 { font-size: 1.6rem; }
  }

  .layout-grid {
    flex-direction: column;
    gap: 30px;
  }

  .sidebar {
    width: 100%;
    position: static;
    
    .side-nav ul {
      display: flex;
      overflow-x: auto;
      white-space: nowrap;
      
      &::-webkit-scrollbar { display: none; }

      li {
        border-bottom: none;
        border-right: 1px solid $border;
        &:last-child { border-right: none; }
        
        a {
          padding: 12px 16px;
          border-left: none !important;
          border-bottom: 3px solid transparent;
        }

        &.active a {
          border-left: none !important;
          border-bottom: 3px solid $accent-red;
        }
      }
    }
  }

  .content-section {
    margin-bottom: 40px;
    overflow-x: hidden;
    .section-title { font-size: 1.4rem; }
    
    /* 手机端富文本额外优化 */
    ::v-deep .intro-text, 
    ::v-deep .placeholder-img, 
    ::v-deep .culture-cards {
      table {
        font-size: 0.85rem;
      }
    }
  }

  .main-content {
    overflow-x: hidden;
    width: 100%;
  }

  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .org-chart {
    padding: 20px 10px;
    overflow-x: auto;
    align-items: flex-start;
    
    .org-level { gap: 20px; }
    .org-departments {
      grid-template-columns: repeat(3, minmax(130px, 1fr));
      gap: 15px;
    }
  }

  .culture-cards .culture-card {
    flex-direction: column;
    align-items: flex-start;
    padding: 20px;
    
    .card-icon {
      width: 50px;
      height: 50px;
      font-size: 1.8rem;
    }
  }

  .contact-grid {
    grid-template-columns: 1fr;
  }

  .discipline-box {
    padding: 20px;
    margin-top: 30px;

    .discipline-header {
      h3 { font-size: 1.15rem; }
    }

    .discipline-content {
      grid-template-columns: 1fr;
    }

    .discipline-item {
      padding: 16px;
    }
  }
}
hr {
  border: none;                /* 干掉默认的立体边框 */
  border-top: 1px dashed #ccc; /* 设置浅灰色虚线，2px粗细 */
}
</style>
